import ActiviteSelect from '@/generated/controls/activite/ActiviteSelect.vue';
import Contrat from '@/extend/classes/Contrat';
import Activite from '@/extend/classes/Activite';
import ListData, { ListFilter, ColumnFilter, ListChoix } from '@/generated/classes/ListData';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  extends: ActiviteSelect,
  name: 'ActiviteSelectExtend',
  components: {},
  props: {
    contrat: {
      type: Object as PropType<Contrat>,
      required: true,
    },
    listActiviteId: {
      type: Array as PropType<Number[]>,
      required: false
    },
    index: { 
      type: Number,
      required: false
    }
  },
  data() {
    return {
      activeFilters: [] as ColumnFilter[],
    };
  },
  computed: {
    items(): Activite[] {
      if (this.reset != this.toggleReset) {
        this.reset = this.toggleReset;
        this.listActivite = [];
        Activite.list(this.artisteFilter)
          .then((data: ListData) => {
            const activites = data.reccords as Activite[];
            activites.forEach((activite: Activite) => {
              if (this.compatibleCi98(activite) && activite.code != "Repet3h" && activite.code != "Repet4h") {
                this.listActivite.push(activite);
              }
            })
            this.listUpdated = true;
          }).catch(() => {
            //Catch empty list
          });
      }
      return this.listActivite;
    },
    artisteFilter(): ListFilter {
      const res = new ListFilter();
      if (!this.contrat.artiste) {
        const columnFilter = new ColumnFilter();
        columnFilter.name = "artiste";
        columnFilter.staticFilter = true;
        const choix = new ListChoix();
        choix.value = 0;
        columnFilter.filters.push(choix);
        res.columnsFilter.push(columnFilter);
      }
      return res;
    },
  },
  methods: {
    compatibleCi98 (activite: Activite): boolean {
      let res = true;
      let isheures = false;
      let isCachets = false;
      const heures: Number[] = [5, 6, 7];
      const cachets: Number[] = [1, 2];
      if (this.listActiviteId) {
        this.listActiviteId.forEach((val, index) => {
          if (heures.includes(val) && index != this.index) {
            isheures = true;
          }
          if (cachets.includes(val) && index != this.index) {
            isCachets = true;
          }
        });
      }
      if ((isCachets && heures.includes(activite.id)) ||
          (isheures && cachets.includes(activite.id))) {
        res = false;
      }
      return res
    }
  }
});
